import type {
  FlowType,
  PSIFlowSummary,
  PSIFlowDetail,
  FlowStatsResponse,
} from '../types/psiFlow';
import { get, buildUrl } from './apiClient';

const API_BASE = '/api/v1/psi/flows';

// ============================================================================
// Flow Queries
// ============================================================================

export async function listFlows(
  filter?: { type?: FlowType; status?: string }
): Promise<{ flows: PSIFlowSummary[]; total: number }> {
  return get<{ flows: PSIFlowSummary[]; total: number }>(buildUrl(API_BASE, filter));
}

export async function getFlow(flowId: string): Promise<PSIFlowDetail> {
  return get<PSIFlowDetail>(`${API_BASE}/${flowId}`);
}

// ============================================================================
// Reminders & Stats
// ============================================================================

export async function getFlowReminders(): Promise<{ reminders: PSIFlowSummary[]; total: number }> {
  return get<{ reminders: PSIFlowSummary[]; total: number }>(`${API_BASE}/reminders`);
}

export async function getFlowStats(): Promise<FlowStatsResponse> {
  return get<FlowStatsResponse>(`${API_BASE}/stats`);
}
